import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes , } from '@angular/router';
import { PowerBiEmbedComponent } from './mq/embed/power-bi-embed/power-bi-embed.component';
import { AuthGuard } from './common/auth.guard';

const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./mq/pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./mq/pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'chat-board',
    loadChildren: () => import('./mq/pages/chat-board/chat-board.module').then( m => m.ChatBoardPageModule),
    
  },

  {
    path: 'error',
    loadChildren: () => import('./mq/pages/error/error.module').then( m => m.ErrorPageModule)
  },
 
  { path: ':option', component: PowerBiEmbedComponent },
 
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules },)
  ],
  exports: [RouterModule,]
})
export class AppRoutingModule { }
